import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import {LoaderService} from "../../../../services/loader/loader.service";
import {ActivatedRoute} from "@angular/router";
import {RestResponse} from "../../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../../Helper/RestHelper";
import {Filter} from "../../../../Interfaces/filter.interface";

@Component({
  selector: 'app-userform',
  templateUrl: './filterform.component.html',
  styleUrl: './filterform.component.css'
})
export class FilterformComponent {

  public userform: FormGroup = this.formBuilder.group({
    displayname: ["", [Validators.required, Validators.minLength(4)]],
    filtername: ["", [Validators.required, Validators.minLength(4)]],
    category: ["", [Validators.required, Validators.minLength(4)]],
    active: ["", [Validators.required]],
  })
  public sentstatus: number = 0

  public operation: string | undefined
  public uuid: string | undefined

  public filter: Filter | undefined

  public apierror: boolean = false

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, protected loader: LoaderService, private route: ActivatedRoute) {
    this.loader.showLoader()

    this.route.params.subscribe(params => {
      this.operation = params['operation']
      this.uuid = params['uuid']
    });

    if (this.operation === "edit" || this.operation === "delete") {
      if (this.uuid === undefined) {
        //TODO Error UUID ist benötigt wenn create, update oder delete
        return
      }

      //TODO getFilter anpassen
      this.httpClient.get<RestResponse<Filter>>(RestHelper.API_BASE_URL + "filtercategory/getFilter?uuid=" + this.uuid, RestHelper.requestOptions).subscribe({
        next: (value) => {
          console.log(value.data)

          this.filter = value.data

          console.log(this.filter)

          this.getFormControls()['displayname'].setValue(this.filter.displayname)
          this.getFormControls()['filtername'].setValue(this.filter.filtername)

          //TODO Category
          this.getFormControls()['category'].setValue(this.filter)
          this.getFormControls()['active'].setValue(this.filter.active)

          if (this.operation === "delete") {
            this.userform.disable()
          }

          this.loader.hideLoader()
          this.apierror = false
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    } else {
      this.loader.hideLoader()
    }
  }

  public getOperation(): string {
    switch (this.operation) {
      case "create":
        return "Erstellen"
      case "edit":
        return "Bearbeiten"
      case "delete":
        return "Löschen"
    }
    return ""
  }

  public onSubmit() {
    if (!this.userform.valid) {
      this.userform.markAllAsTouched()
      for (let el in this.userform.controls) {
        if (this.userform.controls[el].errors) {
          console.log(el)
        }
      }
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("displayname", this.userform.value.displayname)
    body.append("filtername", this.userform.value.filtername)
    body.append("category", this.userform.value.category)
    body.append("active", this.userform.value.active)

    if (this.operation === "edit") {
      body.append("uuid", String(this.uuid))
    }
    if (this.operation === "create") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'searchfilter/createSearchFilter', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
            this.userform.reset()
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    } else if (this.operation === "edit") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'searchfilter/updateSearchFilter', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    }
  }

  public getFormControls() {
    return this.userform.controls;
  }

  protected readonly console = console;
}
